export const nl = {
  home: {
    download: {
      ios: 'Download in de App Store',
      iosSubtitle: 'iPhone & iPad',
      cta: 'Downloaden',
    },
    location: {
      useMyLocation: 'Gebruik mijn locatie',
      modalBadge: 'Locatie',
      modalTitle: 'Kies een stad',
      tabs: {
        cities: 'Steden',
        coords: 'Coördinaten',
      },
      searchPlaceholder: 'Zoek een stad…',
      refresh: 'Vernieuwen',
      loading: 'Steden laden…',
      empty: 'Geen steden gevonden.',
      loadError: 'De steden konden niet worden geladen. Probeer het opnieuw.',
      scrollMore: 'Scroll om meer te laden…',
      coords: {
        latitude: 'Breedtegraad',
        longitude: 'Lengtegraad',
        timezone: 'Tijdzone (optioneel)',
        latPlaceholder: 'bijv. 52.3676',
        lngPlaceholder: 'bijv. 4.9041',
        tzPlaceholder: 'bijv. Europe/Amsterdam',
        tzHint: 'Laat je dit leeg, dan gebruiken we de tijdzone van je apparaat.',
        apply: 'Coördinaten gebruiken',
        clear: 'Wissen',
        invalidLat: 'De breedtegraad moet tussen -90 en 90 liggen.',
        invalidLng: 'De lengtegraad moet tussen -180 en 180 liggen.',
      },
    },
    header: {
      brand: 'Deenly',
      login: 'Inloggen',
      downloadApp: 'App downloaden',
      prayers: {
        fajr: 'Fajr',
        dhuhr: 'Dhuhr',
        asr: 'Asr',
        maghrib: 'Maghrib',
        isha: 'Isha',
      },
    },
    hero: {
      badge: 'Grote update 2.0',
      titleLine1: 'Jouw complete',
      titleGradient: 'deen, opnieuw bedacht.',
      subtitle:
        'Van een rijke feed met geleerden en Tajweed met AI tot de Kaaba in AR, live vertaalde khutbahs en een Kindermodus met pincode. Alles wat je nodig hebt.',
    },
    nextPrayer: {
      label: 'Volgend gebed',
      statusOnTime: 'Op tijd',
      startsIn: 'Begint over',
      meta: {
        locationLabel: 'Sarajevo',
        methodLabel: 'MWL-berekening',
        alertsOn: 'Meldingen aan',
        alertsOff: 'Meldingen uit',
      },
    },
    podcast: {
      badge: 'PODCAST MET GELEERDEN',
      titlePrefix: 'Boekuitleg:',
      titleMain: 'Riyad as-Salihin',
      author: 'Sheikh Mufti Menk',
    },
    features: {
      title: 'Alles wat je nodig hebt.',
      subtitle: 'Zorgvuldig gemaakte hulpmiddelen om te lezen, te luisteren, je voortgang bij te houden en je dagelijkse aanbidding.',
      core: {
        dynamicFeed: {
          title: 'Dynamische feed',
          body: 'Boeken, pagina’s, hadiths, een vers per dag en podcasts die klassieke teksten uitleggen.',
          bookAddedLabel: 'Boek toegevoegd',
          bookAddedValue: 'De Verzegelde Nectar',
          podcastLabel: 'Podcast',
          podcastValue: 'Tafsir Ibn Kathir',
        },
        mosqueNavigator: {
          badge: 'Live navigatie',
          title: 'Slimme moskeenavigator',
          body:
            "Navigatie van wereldklasse, stap voor stap naar de dichtstbijzijnde moskee. Kies je favoriete moskee, zie hoe laat je aankomt en mis nooit meer de Jama'ah.",
          cardTitle: 'Centrale moskee',
          cardMeta: 'Aankomst: 5 min • Lopend',
        },
        dreamInterpreter: {
          title: 'Droomuitleg met AI',
          body: 'Begrijp je dromen vanuit islamitisch perspectief, met onze AI die getraind is op klassieke teksten.',
          cta: 'Vraag het nu',
        },
        libraryStats: {
          title: 'Slimme bibliotheek en statistieken',
          body:
            'Lees moeiteloos in de Koran. Houd een vers lang ingedrukt om er een bladwijzer aan toe te voegen, of open het Tajweed-venster om hardop te lezen en meteen feedback van AI op je uitspraak te krijgen. Met de interactieve schuifregelaar reken je precies uit wanneer je de Koran uit hebt.',
          chips: {
            pages: 'Pagina’s',
            bookmarks: 'Bladwijzers',
            tajweedCheck: 'Tajweed-check',
          },
          paceLabel: 'Dagelijks tempo',
          paceValue: '20 verzen',
          finishLabel: 'Koran uit in',
          finishValue: '105 dagen',
          longPressLabel: 'Lang indrukken',
          longPressValue: 'Vers 255',
        },
      },
      premium: {
        badge: 'Ultieme collectie',
        title: 'Islamitische premium-tools',
        subtitle: 'Een complete set krachtige hulpmiddelen voor iedere moslim.',
        arQibla: {
          title: 'AR-Qibla en Kaaba',
          body:
            'Vind de exacte richting van de Qibla met geavanceerde AR. Zet een virtuele Kaaba recht voor je neer en beleef het alsof je er bent.',
          cta: 'AR-weergave openen',
        },
        postureGuide: {
          title: 'Gebedshoudingen',
          body:
            'Leg je telefoon neer met het scherm naar je toe. Onze AI herkent je bewegingen en begeleidt je precies door de houdingen van het gebed.',
        },
        liveKhutbah: {
          title: 'Live khutbah',
          body:
            "Bid je de Jumu'ah in het buitenland? Dan vertaalt AI de preek van de imam direct op je scherm.",
        },
        tajweed: {
          title: 'Koranrecitatie met AI',
          body:
            'Oefen je recitatie. De AI luistert naar je Tajweed en laat meteen zien wat beter kan, met nauwkeurige feedback.',
        },
        essentials: {
          title: 'Onmisbaar voor elke dag',
          body:
            'En verder alles wat je nodig hebt: een halal-barcodescanner voor ingrediënten, een klassieke Tap Tasbih en een nauwkeurige zakatcalculator.',
          halalScanner: 'Halal-scanner',
          tapTasbih: 'Tap Tasbih',
          zakat: 'Zakatcalculator',
        },
      },
    },
    kids: {
      badge: 'Deenly Kids',
      title: 'Een veilige, mooie plek voor je kleintjes.',
      subtitle:
        'Alles wat je kind nodig heeft om te leren en rustig te slapen, veilig afgeschermd met een pincode voor ouders.',
      items: {
        pictureBooks: {
          title: 'Prentenboeken',
          body: 'Interactieve, prachtig geïllustreerde verhalen die islamitische waarden en normen meegeven.',
        },
        lullabies: {
          title: 'Halal slaapliedjes (zonder muziek)',
          body: 'Rustgevende stemmen, speciaal opgenomen om baby’s vredig in slaap te laten vallen. Volledig zonder muziek.',
        },
        whiteNoise: {
          title: 'Witte ruis en slaapgeluiden',
          body: 'Een selectie rustgevende natuurgeluiden en witte ruis die je kind helpen tot rust te komen.',
        },
        games: {
          title: 'Interactieve spelletjes',
          body: 'Boeiende, veilige en volledig leerzame minigames, helemaal afgestemd op jonge kinderen.',
        },
        pin: {
          title: 'Beveiligde pincodemodus',
          badge: 'Vergrendeld',
          body: 'Kinderen blijven binnen de veilige Kids-omgeving. Zonder jouw pincode kunnen ze er niet uit.',
        },
      },
    },
    cta: {
      title: 'Begin vandaag aan je reis.',
      subtitle: 'Sluit je aan bij miljoenen moslims wereldwijd die met Deenly elke dag betere gewoontes opbouwen.',
      ios: 'Download voor iOS',
      android: 'Download voor Android',
    },
    footer: {
      copyright: '© 2023 Deenly. Alle rechten voorbehouden.',
      links: {
        privacy: 'Privacybeleid',
        terms: 'Servicevoorwaarden',
        contact: 'Contact',
      },
    },
  },
  legal: {
    privacy: {
      metaTitle: 'Privacy en voorwaarden • Deenly',
      header: {
        badge: 'Juridisch document',
        back: 'Terug',
      },
      hero: {
        titlePrefix: 'Ons ',
        titleGradient: 'privacybeleid.',
        subtitle:
          'Jouw gegevens zijn jouw zaak, niet de onze. Ons uitgangspunt: zo weinig mogelijk verzamelen en toch een ervaring van wereldklasse bieden.',
        lastUpdatedLabel: 'Laatst bijgewerkt',
        badgeIcon: 'solar:shield-check-linear',
        calendarIcon: 'solar:calendar-linear',
      },
      languageLabel: 'Taal',
      lang: {
        en: 'English',
        bs: 'Bosanski',
        de: 'Deutsch',
        nl: 'Nederlands',
        fr: 'Français',
      },
      search: {
        title: 'Zoeken',
        placeholder: 'Zoeken (bijv. “gegevens”, “account”, “derden”)',
        found: 'Gevonden onderdelen',
        clear: 'Wissen',
        tocTitle: 'Inhoud',
        tocHint: 'Ga direct naar een onderdeel.',
        emptyTitle: 'Geen resultaten',
        emptyBody:
          'Geen enkel onderdeel past bij je zoekopdracht. Probeer een ander zoekwoord.',
        backToTop: 'Terug naar boven',
        backHome: 'Terug naar de startpagina',
      },
      tldr: {
        title: 'Kort samengevat',
        icon: 'solar:bolt-linear',
        cards: [
          {
            icon: 'solar:eye-closed-linear',
            title: 'Nooit advertenties',
            body: 'We verkopen je gegevens niet aan adverteerders. Deenly wordt volledig gedragen door premium-abonnementen.',
          },
          {
            icon: 'solar:map-point-linear',
            title: 'Locatie blijft lokaal',
            body: 'Gebedstijden worden rechtstreeks op je apparaat berekend. We volgen je bewegingen nooit.',
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Versleutelde synchronisatie',
            body: 'Je bladwijzers en persoonlijke statistieken zijn versleuteld, zowel tijdens het verzenden als bij de opslag.',
          },
          {
            icon: 'solar:smile-circle-linear',
            title: 'Kinderen zijn veilig',
            body: 'De Kindermodus voldoet aan COPPA en verzamelt helemaal geen telemetrie.',
          },
        ],
      },
      toc: [
        { id: 'tldr', label: 'Kort samengevat' },
        { id: 'collection', label: 'Verzameling' },
        { id: 'usage', label: 'Gebruik van gegevens' },
        { id: 'kids', label: 'Privacy van kinderen' },
        { id: 'sharing', label: 'Delen' },
        { id: 'security', label: 'Beveiliging' },
        { id: 'contact', label: 'Neem contact op' },
      ],
      collection: {
        title: 'Welke gegevens we verzamelen',
        intro:
          'We verzamelen zo min mogelijk gegevens. Dit is precies wat er gebeurt wanneer je Deenly gebruikt.',
        items: [
          {
            icon: 'solar:key-minimalistic-2-linear',
            title: 'Apparaatidentiteit (UUID)',
            bodyParts: [
              { text: 'Bij de eerste keer openen maakt de app een willekeurige ', highlight: false },
              { text: 'UUID', highlight: true },
              { text: ' aan en bewaart die veilig in de sessie van je apparaat (Keychain / Keystore). Deze identificatie wordt uitsluitend gebruikt om je apparaat bij onze servers te registreren. Ze verlaat je apparaat alleen om je bij onze API te authenticeren.', highlight: false },
            ],
          },
          {
            icon: 'solar:lock-keyhole-minimalistic-linear',
            title: 'Sessietoken (JWT)',
            bodyParts: [
              { text: 'Na de registratie geeft onze server een ', highlight: false },
              { text: 'JWT', highlight: true },
              { text: ' uit die uitsluitend in de sessie van je apparaat wordt bewaard. Alle volgende API-verzoeken gebruiken dit token. Er is geen gewone inlog met gebruikersnaam en wachtwoord: je identiteit is de sessie van je apparaat.', highlight: false },
            ],
          },
          {
            icon: 'solar:routing-2-linear',
            title: 'Locatiegegevens (op je apparaat)',
            bodyParts: [
              { text: 'Uitsluitend nodig om nauwkeurige gebedstijden en de richting van de Qibla te berekenen. De berekening gebeurt ', highlight: false },
              { text: 'lokaal op je apparaat', highlight: true },
              { text: '. We bewaren je locatiegeschiedenis nooit en versturen die ook nooit.', highlight: false },
            ],
          },
          {
            icon: 'solar:mic-2-linear',
            title: 'Toegang tot de microfoon',
            body:
              'Gebruikt voor de recitatiecontrole met AI en de vertaling van de live khutbah. De spraakherkenning draait op je apparaat: de audio zelf wordt door ons nooit geüpload, opgenomen of bewaard. Wat je apparaat wel kan verlaten, is tekst, zoals hieronder beschreven.',
          },
          {
            icon: 'solar:document-text-linear',
            title: 'Tekstverwerking door AI (transcripties en dromen)',
            bodyParts: [
              { text: 'Sommige AI-functies vragen meer rekenkracht dan een telefoon heeft. Gebruik je de vertaling van de live khutbah, dan wordt de herkende ', highlight: false },
              { text: 'tekst van elke zin', highlight: true },
              { text: ' (nooit de audio) via een versleutelde verbinding naar onze servers gestuurd en doorgegeven aan een vertrouwde AI-verwerkingspartner, die de vertaling en de samenvatting aan het einde van de khutbah maakt. Droombeschrijvingen die je bij de Droomuitleg indient, worden op dezelfde manier verwerkt. Deze verzoeken bevatten alleen de sessie van je apparaat, niet je naam of contactgegevens. Je khutbah-geschiedenis wordt alleen op je apparaat bewaard; vertalingen blijven tot 30 dagen in de cache op onze servers, zodat een hele gemeente die dezelfde khutbah volgt ze meteen krijgt; gedeelde transcripties van een "room" worden binnen enkele uren van onze servers verwijderd.', highlight: false },
            ],
          },
        ],
      },
      usage: {
        title: 'Hoe we gegevens gebruiken',
        intro:
          'De gegevens die we wel verzamelen, gebruiken we uitsluitend om je ervaring te verbeteren. We doen niet aan gedragsprofilering.',
        cards: [
          {
            icon: 'solar:cloud-sync-linear',
            title: 'Synchronisatie via de cloud',
            body:
              'Synchroniseer je Koranbladwijzers, dagelijkse statistieken en instellingen moeiteloos tussen je apparaten.',
          },
          {
            icon: 'solar:magic-stick-3-linear',
            title: 'Verwerking voor AI-functies',
            body:
              'De vertaling van de khutbah zin voor zin, de samenvattingen van de khutbah en de droomuitleg worden gemaakt op basis van tekst die naar onze servers en een vertrouwde AI-verwerkingspartner wordt gestuurd. Verzoeken zijn alleen gekoppeld aan de sessie van je apparaat en worden nooit gebruikt om een profiel van je op te bouwen.',
          },
        ],
      },
      kids: {
        title: 'Privacy in de Kindermodus',
        intro:
          'We nemen de privacy van minderjarigen uiterst serieus. Het kindergedeelte is een zeer veilige omgeving die in de eerste plaats offline werkt.',
        badge: {
          icon: 'solar:star-fall-minimalistic-2-linear',
          label: 'Bijzondere bepaling',
        },
        items: [
          {
            icon: 'solar:shield-check-linear',
            text: 'Geen enkel tracking- of analysescript in de Kindermodus.',
          },
          {
            icon: 'solar:document-text-linear',
            text: 'Voldoet volledig aan COPPA en GDPR-K.',
          },
          {
            icon: 'solar:lock-password-linear',
            text: 'Geen externe links of aankopen zonder de pincode van de ouder.',
          },
        ],
      },
      sharing: {
        title: 'Gegevens delen',
        body:
          'We verkopen, verhuren of ruilen je persoonlijke gegevens niet met derden. We delen gegevens alleen met zeer betrouwbare infrastructuurpartners, en uitsluitend om de app te laten werken. Daartoe behoort een AI-verwerkingspartner die alleen de tekst ontvangt die nodig is voor een functie (een zin uit de khutbah om te vertalen, een droombeschrijving om uit te leggen), nooit je identiteit. Deze partners zijn gebonden aan strikte geheimhoudingsafspraken en mogen je gegevens niet voor eigen doeleinden gebruiken, ook niet voor advertenties of om op je inhoud te trainen.',
      },
      security: {
        title: 'Beveiligingsmaatregelen',
        body:
          'Jouw vertrouwen is ons grootste goed. We gebruiken de modernste beveiligingsmaatregelen om je gegevens te beschermen. Alle communicatie is beveiligd met TLS-versleuteling. Je UUID en JWT worden alleen bewaard in de beveiligde sessie van je apparaat (Keychain op iOS, Keystore op Android) en zijn nooit toegankelijk buiten je apparaat.',
      },
      contactCta: {
        title: 'Vragen over je privacy?',
        subtitle: 'Ons privacyteam helpt je graag.',
        button: 'Neem contact op met het privacyteam',
        icon: 'solar:letter-linear',
      },
      footerNote: 'Alle rechten voorbehouden. Ontworpen met zuivere bedoelingen.',
      footer: {
        links: {
          terms: 'Voorwaarden',
          privacy: 'Privacy',
          cookies: 'Cookies',
        },
      },
    },
  },
};
